import { ReactNode, useContext, useEffect, useRef } from "react";
import styled from "styled-components";

import { DatePickerContext } from "./DatePickerContext";

import Box from "../Box/Box";

interface DatePickerContainerProps {
  id?: string;
  children: ReactNode;
}

const DatePickerContainerStyled = styled(Box)`
  position: relative;
`;

const DatePickerContainer = ({ id, children }: DatePickerContainerProps) => {
  const { setShowCalendar } = useContext(DatePickerContext);
  const node = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      if (node.current && node.current.contains(e.target as Node)) {
        return;
      }
      setShowCalendar(false);
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [setShowCalendar]);

  return (
    <DatePickerContainerStyled id={id} ref={node}>
      {children}
    </DatePickerContainerStyled>
  );
};

export default DatePickerContainer;
